// extracted by mini-css-extract-plugin
export default {"form":"forgot-password_form__1ax7N","message":"forgot-password_message__uTPaJ","reLogin":"forgot-password_reLogin__A64b9","actions":"forgot-password_actions__EO0jf"};